import { Stack } from "@mui/system";
import { useState } from "react";
import { DropdownSubItem } from "../../../../ui/dropdown/DropdownSubItem";
import { DropdownWithSearchWrapper } from "../../../../ui/dropdown/DropdownWithSearchWrapper";
import { ChipsList } from "./ChipsList";
import { AccountSize } from "../../../../../types/apiTypes";
import { CustomChip } from "../../../../ui";

const ROW_LENGTH = 4;

type Props = {
  items: AccountSize[];
  selected: AccountSize[];
  setSelected: React.Dispatch<React.SetStateAction<AccountSize[]>>;
};

export const SizesDropdown = ({ items, selected, setSelected }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");

  const [internalSelected, setInternalSelected] =
    useState<AccountSize[]>(selected);

  const cancelHandler = () => {
    setIsOpen(false);
    setSearch("");
    setInternalSelected(selected);
  };

  const submitHandler = () => {
    setIsOpen(false);
    setSearch("");
    setSelected(internalSelected);
  };

  const toogleItem = (sizeItem: AccountSize) => {
    const existingItem = internalSelected.find(
      (item) => item.id === sizeItem.id,
    );

    if (existingItem) {
      setInternalSelected((prev) =>
        prev.filter((item) => item.id !== sizeItem.id),
      );
    } else {
      setInternalSelected((prev) => [...prev, sizeItem]);
    }
  };

  const removeItem = (id: string) => {
    const updated = selected.filter((item) => item.id !== id);

    setInternalSelected(updated);
    setSelected(updated);
  };

  const isSelected = (sizeItem: AccountSize) =>
    internalSelected.some((item) => item.id === sizeItem.id);

  const filteredItems = items.filter((item) =>
    item.display.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <Stack gap="8px">
      <DropdownWithSearchWrapper
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        search={search}
        setSearch={setSearch}
        placeholder="Select Company Size"
        selectedCount={selected.length}
        submitHandler={submitHandler}
        cancelHandler={cancelHandler}
        closeHandler={cancelHandler}
        fullwidth
        listMinHeight={"140px"}
      >
        {filteredItems.map((item) => (
          <DropdownSubItem
            key={item.id}
            title={item.display}
            checked={isSelected(item)}
            onClick={() => toogleItem(item)}
          />
        ))}
      </DropdownWithSearchWrapper>

      <ChipsList
        items={selected}
        rowLength={ROW_LENGTH}
        renderItem={(item) => (
          <CustomChip
            key={item.id}
            label={item.display}
            onDelete={() => removeItem(item.id)}
          />
        )}
      />
    </Stack>
  );
};
